import { NgModule } from '@angular/core';
import { GlobalHeaderModule } from '@features/global-header/global-header.module';
import { FooterModule } from '@features/global-footer/footer.module';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [],

	imports: [
		CommonModule,
		GlobalHeaderModule,
		FooterModule,
	],
	exports: [
		CommonModule,
		FooterModule,
		GlobalHeaderModule,
	],
})
export class FeaturesModule { }
